// 缓存中的key


/** 机构id */
export const OGRAN_ID =  `ogran_id`

// 

/** 用户信息 */
export const USER  = 'user'

// 书籍
export const BOOK_DATA = "book-data";


// WEBPACK FOOTER //
// ./src/constant/storage.js